<template>
  <div>
    <div class="tabs-right-type h-96">
      <div
        class="tab"
        v-for="(item, index) in options"
        :key="item.key"
        :class="{
          active: item.key === curTab,
        }"
        @click="() => handleTabClick(item.key)"
      >
        <template v-if="item.key === curTab">
          <img
            v-if="index === 0"
            class="tabs-right-type-bg left"
            src="@/assets/img/chargingVoucher/right-type-selected-bg.png"
          >
          <img
            v-else-if="index === options.length - 1"
            class="tabs-right-type-bg right"
            style="scale: -1 1"
            src="@/assets/img/chargingVoucher/right-type-selected-bg.png"
          >
          <img
            v-else
            class="tabs-right-type-bg"
            src="@/assets/img/chargingVoucher/right-type-selected-bg.png"
          >
        </template>
        <div class="tab-text">
          {{ item.text }}
        </div>
      </div>
    </div>
    <div class="h-96" />
  </div>
</template>

<script>
export default {
  name: 'TabsRightType',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    curTab: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  methods: {
    handleTabClick(key) {
      this.$emit('tabClick', key);
    }
  }
};
</script>

<style lang="scss" scoped>
.tabs-right-type {
  width: 100vw;
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  z-index: 999;
  box-sizing: border-box;
  background: #e6e6e6;

  .tab {
    flex: 1;
    font-size: 32px;
    color: #646464;
    letter-spacing: -1.48px;
    text-align: center;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 45px;
    height: 100%;

    .tab-text {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.active {
      font-size: 32px;
      color: #383838;
      letter-spacing: -1.48px;
      text-align: center;
      font-weight: bold;
      line-height: 45px;

      .tab-text {
        position: relative;
        z-index: 3;
      }
    }
    .tabs-right-type-bg {
      position: absolute;
      z-index: 2;
      width: 415px;
      height: 96px;
      object-fit: contain;
    }
  }
}
.h-96 {
  height: 96px;
}
.border-bl {
  border-bottom-left-radius: 21px;
}
.border-br {
  border-bottom-right-radius: 21px;
}
</style>
